export const NAVIGATION_BUTTON_CLICKED = 'action.navigation.button.clicked';

export const navigationButtonClicked = button => {
    return {
        type: NAVIGATION_BUTTON_CLICKED,
        button,
    };
};
